import { render } from "./PageStatistique.vue?vue&type=template&id=31306e6b&scoped=true"
import script from "./PageStatistique.vue?vue&type=script&lang=js"
export * from "./PageStatistique.vue?vue&type=script&lang=js"

import "./PageStatistique.vue?vue&type=style&index=0&id=31306e6b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31306e6b"]])

export default __exports__